import { authApi } from './auth.js';
import { orgsApi } from './orgs.js';
import { usersApi } from './users.js';
import { sitesApi } from './sites.js';
import { locationsApi } from './locations.js';
import { assetsApi } from './assets.js';
import { workOrdersApi, tasksApi } from './work-orders.js';
import { invitationsApi } from './invitations.js';
import { teamsApi } from './teams.js';
import { rolesApi, permissionsApi } from './roles.js';
import { vendorsApi } from './vendors.js';
import { partsApi } from './parts.js';
import { chatApi } from './chat.js';
import { checklistsApi } from './checklists.js';
import { analyticsApi } from './analytics.js';
import { requestsApi } from './requests.js';
import { workflowsApi } from './workflows.js';
import { slaApi } from './sla.js';
import { reportsApi } from './reports.js';
import { notificationsApi } from './notifications.js';
import { trashApi } from './trash.js';
import { superAdminApi } from './super-admin.js';
import { systemHealthApi } from './system-health.js';
import { integrationsApi } from './integrations.js';
import { exportsApi } from './exports.js';
import { customersApi } from './customers.js';
import { customerGroupsApi } from './customer-groups.js';
import { orgStructureApi } from './org-structure.js';
import { inboundEmailApi } from './inbound-email.js';
import { issueTemplatesApi, publicLocationQrApi } from './issue-templates.js';
import { reportTemplatesApi } from './report-templates.js';
import { tagsApi } from './tags.js';
import { feedbackApi } from './feedback.js';
import { feedbackAnalyticsApi } from './feedback-analytics.js';
export * from './client.js';
export * from './errors.js';
export * from './bulk-delete.js';
export * from './auth.js';
export * from './orgs.js';
export * from './users.js';
export * from './sites.js';
export * from './locations.js';
export * from './assets.js';
export * from './work-orders.js';
export * from './invitations.js';
export * from './teams.js';
export * from './roles.js';
export * from './vendors.js';
export * from './parts.js';
export * from './chat.js';
export * from './checklists.js';
export * from './analytics.js';
export * from './requests.js';
export * from './workflows.js';
export * from './sla.js';
export * from './reports.js';
export * from './notifications.js';
export * from './trash.js';
export * from './super-admin.js';
export * from './integrations.js';
export * from './exports.js';
export * from './customers.js';
export * from './customer-groups.js';
export * from './org-structure.js';
export * from './inbound-email.js';
export * from './issue-templates.js';
export * from './report-templates.js';
export * from './tags.js';
export * from './feedback.js';
export * from './feedback-analytics.js';
/** Bundles every resource module into a single typed API surface. */
export function createApi(client) {
    return {
        auth: authApi(client),
        orgs: orgsApi(client),
        users: usersApi(client),
        sites: sitesApi(client),
        locations: locationsApi(client),
        assets: assetsApi(client),
        workOrders: workOrdersApi(client),
        tasks: tasksApi(client),
        invitations: invitationsApi(client),
        teams: teamsApi(client),
        roles: rolesApi(client),
        permissions: permissionsApi(client),
        vendors: vendorsApi(client),
        parts: partsApi(client),
        chat: chatApi(client),
        checklists: checklistsApi(client),
        analytics: analyticsApi(client),
        requests: requestsApi(client),
        workflows: workflowsApi(client),
        sla: slaApi(client),
        reports: reportsApi(client),
        notifications: notificationsApi(client),
        trash: trashApi(client),
        superAdmin: superAdminApi(client),
        systemHealth: systemHealthApi(client),
        integrations: integrationsApi(client),
        exports: exportsApi(client),
        customers: customersApi(client),
        customerGroups: customerGroupsApi(client),
        orgStructure: orgStructureApi(client),
        inboundEmail: inboundEmailApi(client),
        issueTemplates: issueTemplatesApi(client),
        reportTemplates: reportTemplatesApi(client),
        publicLocationQr: publicLocationQrApi(client),
        tags: tagsApi(client),
        feedback: feedbackApi(client),
        feedbackAnalytics: feedbackAnalyticsApi(client),
    };
}
//# sourceMappingURL=index.js.map